import contactAdminSvg from 'images/contact-admin.svg'

export default function ErrorView() {
  return (
    <div className="w-full flex flex-col items-center">
      <p className="font-bold text-[18px] p-8">
        Sorry, you do not have access to this tool. If you think you should have
        access, please talk to your line manager
      </p>
      <img src={contactAdminSvg} className="w-1/4 mt-8" alt="contact admin" />
    </div>
  )
}
